import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DeleteOutlined",
  "use": "DeleteOutlined-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"DeleteOutlined\"><path d=\"M5 2h4v.999h1V1.875a1 1 0 0 0-1-1H4.875c-.552 0-.875.448-.875 1v1.124h1V2zm7.5.999h-11a.5.5 0 0 0-.5.5v.376c0 .069.056.125.125.125h.944l.385 8.047a1 1 0 0 0 .999.953h7.094a.999.999 0 0 0 .998-.953L11.931 4h.944A.125.125 0 0 0 13 3.875v-.376a.5.5 0 0 0-.5-.5zM10.426 12H3.573l-.378-8h7.61l-.379 8z\" fill-opacity=\".45\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol